import React from 'react';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import { Inner } from 'styles/structure';
import { Rubric } from 'styles/typography';
import LuminousPlayer from 'components/LuminousPlayer';

const FeatureContainer = styled.div`
  overflow: hidden;
  
  & + * {
    margin-top: 6.4rem;
  }
  
  &:last-child {
    margin-bottom: 8rem;
  }
  
  header {
    text-align: center;

    span {
       & + * {
        margin-top: 1.6rem;
       }
    }
    
    & + * {
      margin-top: 4rem;
    }
  }

  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 6.4rem;
    }
  }
`;

const FeaturedResources = props => {
  const { intro, heading, caption, widget } = props;

  return (
    <FeatureContainer>
      <Inner>
        <header>
          <div>
            {intro && <Rubric>{intro}</Rubric>}
            {heading && <h2>{heading}</h2>}
          </div>
        </header>

        <LuminousPlayer
          widget={widget || '0011r00002QWpLv_1624'}
          caption={caption}
        />
      </Inner>
    </FeatureContainer>
  );
};

export default FeaturedResources;
